import { Component, EventEmitter, Output } from '@angular/core';
import {
  COMMON_IMPORTS,
  MATERIAL_IMPORTS,
} from '../../../../shared/imports/common-imports';
import ComplianceElements from '../../../../shared/data/compliance-elements';
import { AuthService } from '../../../auth/services/auth.service';
import { UserRole } from '../../../auth/models/profile';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  imports: [COMMON_IMPORTS, MATERIAL_IMPORTS],
})
export class SidebarComponent {
  @Output() sidebarToggled = new EventEmitter<boolean>();
  isOpen = false;
  therapeuticAreas = [
    { name: 'OBU', icon: 'dna.svg', isExpanded: false },
    { name: 'BBU', icon: 'atom.svg', isExpanded: false },
    { name: 'RDU', icon: 'molecule.svg', isExpanded: false },
  ];

  isAdmin = false;
  complianceElements = ComplianceElements;
  footerOffset = 0; // Track footer offset in pixels
  userTasAccess: string[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    const profile = this.authService.getProfile();
    if (profile && profile.role === UserRole.ADMIN) this.isAdmin = true;

    const userPrivileges = this.authService.dbUserData;
    this.userTasAccess = userPrivileges?.therapeutic_areas || [];

    if (userPrivileges) {
      this.isAdmin = this.isAdmin && userPrivileges.role === UserRole.ADMIN;
    }

    if (profile && profile.role !== UserRole.TA_USER) {
      this.userTasAccess = this.therapeuticAreas.map((area) => area.name);
    }

    this.sidebarToggled.emit(this.isOpen);
    this.setupFooterObserver();
  }

  displayForUserArea(area: string): boolean {
    return this.userTasAccess.includes(area);
  }

  ngOnDestroy() {
    if (this.footerObserver) {
      this.footerObserver.disconnect();
    }
  }

  private footerObserver?: IntersectionObserver;

  setupFooterObserver() {
    const footer = document.querySelector('app-footer');
    if (!footer) return;

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible, calculate how much it's overlapping
            const footerRect = entry.boundingClientRect;
            const viewportHeight = window.innerHeight;
            const footerVisibleHeight = viewportHeight - footerRect.top;

            // Set the offset (add a bit of padding for spacing)
            this.footerOffset = Math.max(0, footerVisibleHeight + 16);
          } else {
            // Footer not visible
            this.footerOffset = 0;
          }
        });
      },
      {
        root: null,
        threshold: Array.from({ length: 101 }, (_, i) => i / 100), // Multiple thresholds for smooth tracking
      },
    );

    this.footerObserver.observe(footer);
  }

  toggleSidebar() {
    this.isOpen = !this.isOpen;
    this.sidebarToggled.emit(this.isOpen);
  }

  expandArea(area: any, expanded: boolean) {
    this.therapeuticAreas.forEach((a) => {
      a.isExpanded = false;
    });

    area.isExpanded = expanded;
  }
}
